import type { ComponentPropsWithoutRef } from 'react';

import { cn } from '@shared/lib/utils';

type LandingSphereProps = ComponentPropsWithoutRef<'div'>;

export const LandingSphereDiv = ({ className, ...props }: LandingSphereProps) => {
  return (
    <div
      aria-hidden="true"
      data-sphere
      className={cn(
        `
          relative aspect-square h-auto w-full overflow-hidden rounded-full bg-primary
          mask-radial-[50%_50%] mask-radial-from-100% mask-radial-at-center
        `,
        className
      )}
      {...props}
    >
      <div className="relative size-full blur-xl bg-sphere" />
      <div
        className="
          absolute inset-0 rounded-full bg-transparent
          inset-shadow-[0_0_15px_2px_rgba(255,255,255,1)]
        "
      />
    </div>
  );
};
